import { esc } from '@/utils/escape';

export function generateTestimonialsHTML(data: any, settings: any): string {
  const items = (data.items || [])
    .map((item: any) => {
      const initials = item.author
        .split(" ")
        .map((n: string) => n[0])
        .join("")
        .toUpperCase()
        .slice(0, 2);
      return `        <div class="testimonial">
          <div class="testimonial__stars">★★★★★</div>
          <p class="testimonial__quote">"${esc(item.quote)}"</p>
          <div class="testimonial__author">
            <div class="testimonial__avatar">${initials}</div>
            <div>
              <div class="testimonial__name">${esc(item.author)}</div>
              <div class="testimonial__role">${esc(item.role)}</div>
            </div>
          </div>
        </div>`;
    })
    .join("\n");

  return `  <!-- Testimonials -->
  <section class="testimonials">
    <div class="container">
      <div class="section-header">
        <h2>${esc(data.title)}</h2>
      </div>
      <div class="testimonials__grid">
${items}
      </div>
    </div>
  </section>`;
}
